import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-left px-[16px] flex" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Exportar relatório vagas")
], -1)
const _hoisted_2 = { class: "rounded border border-primary30 mt-2 text-primary" }
const _hoisted_3 = { class: "max-h-[250px] overflow-y-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 font-semibold" }, "Unidades:", -1)
const _hoisted_5 = { class: "flex flex-wrap gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 font-semibold" }, "Escalas:", -1)
const _hoisted_7 = { class: "flex flex-wrap gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mb-1 font-semibold" }, "Horários:", -1)
const _hoisted_9 = { class: "flex flex-wrap gap-2" }
const _hoisted_10 = { class: "flex gap-5 justify-end mt-4 px-3" }

import { ref, computed } from 'vue'
import { startOfMonth, endOfMonth } from 'date-fns'
import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { formatDateToString } from '@/utils/date'
import Network from '@/Network'
import { useToast } from 'vue-toastification'
import { useStationStore } from '@/pinia-store/useStationStore'
import { useHealthUnitStore } from '@/pinia-store/useHealthUnitStore'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { getApiErrorStatus } from '@/utils/apiError'
import { useErrorToast } from '@/composables/useErrorToast'

const unitLimit = 3
const scheduleLimit = 3


export default /*#__PURE__*/_defineComponent({
  __name: 'export.stations.excel.modal',
  setup(__props) {

const modalName = EModals.EXPORT_STATIONS_EXCEL
const modalStore = useModalStore()
const { modals } = storeToRefs(modalStore)

const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}

const healthUnitStore = useHealthUnitStore()
const scheduleStore = useScheduleStore()
const { healthUnitsMap, listHealthUnits } = storeToRefs(healthUnitStore)
const { listSchedules, schedulesMap } = storeToRefs(scheduleStore)
const stationStore = useStationStore()
const { listStationsQuery } = storeToRefs(stationStore)

const today = new Date()
const firstDateOfMonth = startOfMonth(today)
const lastDateOfMonth = endOfMonth(today)
const range = ref({
  start: firstDateOfMonth,
  end: lastDateOfMonth
})

const toast = useToast()
const { notifyError } = useErrorToast()

const isLoading = ref(false)

const hoursFilter = computed(() => {
  if (listStationsQuery.value?.startHour && listStationsQuery.value?.endHour) {
    const startHours = listStationsQuery.value.startHour.split(',')
    const endHours = listStationsQuery.value.endHour.split(',')
    if (startHours.length === 0 || endHours.length === 0 || startHours.length !== endHours.length) {
      return []
    }
    return startHours.map((startHour, i) => ({
      text: `${startHour}-${endHours[i]}`
    }))
  } else if (listStationsQuery.value?.startDate && listStationsQuery.value?.endDate) {
    const startDate = new Date(listStationsQuery.value.startDate)
    const endDate = new Date(listStationsQuery.value.endDate)
    const startHour = startDate.getHours().toString().padStart(2, '0')
    const startMinute = startDate.getMinutes().toString().padStart(2, '0')
    const endHour = endDate.getHours().toString().padStart(2, '0')
    const endMinute = endDate.getMinutes().toString().padStart(2, '0')
    return [
      {
        text: `${startHour}:${startMinute}-${endHour}:${endMinute}`
      }
    ]
  }
  return []
})

const unitsFilter = computed(() => {
  if (
    listStationsQuery.value &&
    listStationsQuery.value.healthUnits &&
    listStationsQuery.value.healthUnits.length > 0
  ) {
    return listStationsQuery.value.healthUnits.map((u) => ({
      id: u,
      text: healthUnitsMap.value.get(+u)
    }))
  } else {
    return listHealthUnits.value.map((unit) => ({
      id: unit.value,
      text: unit.title
    }))
  }
})

const schedulesFilter = computed(() => {
  if (
    listStationsQuery.value &&
    listStationsQuery.value.schedules &&
    listStationsQuery.value.schedules.length > 0
  ) {
    return listStationsQuery.value.schedules.map((u) => ({
      id: u,
      text: schedulesMap.value.get(+u)
    }))
  } else {
    return listSchedules.value.map((schedule) => ({
      id: schedule.value,
      text: schedule.title
    }))
  }
})

const expandedUnits = ref(false)
const expandedSchedules = ref(false)
const limitedUnits = computed(() => {
  return expandedUnits.value ? unitsFilter.value : unitsFilter.value.slice(0, unitLimit)
})

const limitedSchedules = computed(() => {
  return expandedSchedules.value
    ? schedulesFilter.value
    : schedulesFilter.value.slice(0, scheduleLimit)
})

const handleExport = async () => {
  isLoading.value = true
  try {
    const filename = `relatorio-plantoes-${formatDateToString(
      range.value.start
    )}-${formatDateToString(range.value.end)}.xlsx`

    const query = listStationsQuery.value ?? {}
    const healthUnits = (query.healthUnits ?? []).map((v) => String(v))
    const schedules = (query.schedules ?? []).map((v) => String(v))

    const link = await Network.station.exportStationsXlsx({
      ...query,
      startDate: new Date(range.value.start),
      endDate: new Date(range.value.end),
      healthUnits: healthUnits.length ? healthUnits : undefined,
      schedules: schedules.length ? schedules : undefined,
      filename
    })

    document.body.appendChild(link)
    link.click()
    toast.success('Relatório exportado com sucesso')
  } catch (error) {
    // O service embrulha o erro (ServiceError) e faz parse do body de erro do
    // blob — o status vem via getApiErrorStatus (unwrap-safe).
    if (getApiErrorStatus(error) === 404) {
      toast.warning('Nenhum apontamento encontrado dentro do período especificado')
      return
    }
    // Antes: "Erro ao exportar relatório, contate um administrador!" estático.
    notifyError(error, 'Não foi possível exportar o relatório de plantões')
  } finally {
    isLoading.value = false
    handleToggleModal()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleToggleModal,
    modalActive: _unref(modals)[_unref(modalName)],
    hasFooterBorder: true
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(FilledButton, {
          onClick: handleExport,
          text: "Exportar",
          height: "52px",
          width: "180px",
          class: "bg-primary30",
          loading: isLoading.value,
          disabled: isLoading.value
        }, null, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_VDatePicker, {
        modelValue: range.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((range).value = $event)),
        "is-range": "",
        expanded: ""
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, " de " + _toDisplayString(_unref(formatDateToString)(range.value.start)) + " até " + _toDisplayString(_unref(formatDateToString)(range.value.end)), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_row, { class: "text-left" }, {
          default: _withCtx(() => [
            (unitsFilter.value?.length)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  class: "text-sm text-primary",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedUnits.value, (unit) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: unit.id,
                          class: "bg-gray-100 text-gray-800 px-2 py-1 rounded-full text-xs"
                        }, _toDisplayString(unit.text), 1))
                      }), 128)),
                      (unitsFilter.value.length > unitLimit && !expandedUnits.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (expandedUnits.value = true)),
                            class: "text-blue-500 text-xs"
                          }, " Ver Mais "))
                        : _createCommentVNode("", true),
                      (unitsFilter.value.length > unitLimit && expandedUnits.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (expandedUnits.value = false)),
                            class: "text-blue-500 text-xs"
                          }, " Ver Menos "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (schedulesFilter.value?.length)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  class: "text-sm text-primary",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedSchedules.value, (schedule) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: schedule.id,
                          class: "bg-gray-100 text-gray-800 px-2 py-1 rounded-full text-xs"
                        }, _toDisplayString(schedule.text), 1))
                      }), 128)),
                      (schedulesFilter.value.length > scheduleLimit && !expandedSchedules.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (expandedSchedules.value = true)),
                            class: "text-blue-500 text-xs"
                          }, " Ver Mais "))
                        : _createCommentVNode("", true),
                      (schedulesFilter.value.length > scheduleLimit && expandedSchedules.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (expandedSchedules.value = false)),
                            class: "text-blue-500 text-xs"
                          }, " Ver Menos "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (hoursFilter.value?.length)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 2,
                  class: "text-sm text-primary",
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hoursFilter.value, (hour) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: hour.text,
                          class: "bg-gray-100 text-gray-800 px-2 py-1 rounded-full text-xs"
                        }, _toDisplayString(hour.text), 1))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})